import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { connect } from '@atlassian/jira-react-redux';
import type { State } from '../model/types';
import { getChatAppStatus } from '../state/actions';
import {
	getIsLoading,
	getIsEnabled,
	getIsInstalled,
	getErrorReason,
	getErrorMessage,
	getAddonKey,
} from '../state/selectors';
import ChatSettings from './view';

const mapStateToProps = (state: State) => ({
	isLoading: getIsLoading(state),
	isInstalled: getIsInstalled(state),
	isEnabled: getIsEnabled(state),
	errorReason: getErrorReason(state),
	errorMessage: getErrorMessage(state),
	addonKey: getAddonKey(state),
});

const mapDispatchToProps = {
	onGetChatAppStatus: getChatAppStatus,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ChatSettings));
